import 'normalize.css'
import 'typeface-domine'
import 'typeface-montserrat'
import 'prismjs/themes/prism-okaidia.css'
import './src/styles/main.css'
